import { Injectable } from '@angular/core';
import { throwError, Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { HttpProviderService } from '@core/service';
import {
  HttpRequestPayload,
  IHttpSuccessPayload,
  IHttpErrorPayload,
} from '@core/models';

@Injectable()
export class DeliveryOptionsService {
  constructor(private httpProvider: HttpProviderService) {}

  fetchDeliveryOptions(): Observable<any[]> {
    const request: HttpRequestPayload = {
      resource: `/lov`,
      queryParams: [
        {
          key: 'lovId',
          value: 'CB_DLVRY_OPTION',
        },
        {
          key: 'lookup',
          value: '1',
        },
      ],
      method: 'GET',
    };

    return this.httpProvider.invokeApi(request).pipe(
      map((response: IHttpSuccessPayload<any>) => {
        return response.body.Data;
      }),
      catchError((err: IHttpErrorPayload) => {
        return throwError(err);
      })
    );
  }
}
